import confetti from 'canvas-confetti';

export const triggerConfetti = () => {
  // Premier burst au centre
  confetti({
    particleCount: 150,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#ffd700', '#96ceb4', '#ffeaa7']
  });

  // Burst depuis la gauche
  setTimeout(() => {
    confetti({
      particleCount: 80,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.6 },
      colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#ffd700']
    });
  }, 200);

  // Burst depuis la droite
  setTimeout(() => {
    confetti({
      particleCount: 80,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.6 },
      colors: ['#96ceb4', '#ffeaa7', '#ff6b6b', '#45b7d1']
    });
  }, 400);

  // Burst final depuis le haut
  setTimeout(() => {
    confetti({
      particleCount: 100,
      startVelocity: 45,
      spread: 80,
      origin: { x: 0.5, y: 0.2 },
      colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#ffd700', '#96ceb4', '#ffeaa7']
    });
  }, 600);
};

export const triggerSuccessConfetti = () => {
  // Animation pour succès avec plus de couleurs
  const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#ffd700', '#96ceb4', '#ffeaa7', '#dda0dd', '#98fb98'];
  
  // Multiple bursts pour un effet spectaculaire
  for (let i = 0; i < 5; i++) {
    setTimeout(() => {
      confetti({
        particleCount: 50,
        angle: 60 + (i * 15),
        spread: 55,
        origin: { x: 0.1 + (i * 0.2), y: 0.6 },
        colors: colors.slice(i * 2, i * 2 + 4)
      });
    }, i * 150);
  }
  
  // Grand final
  setTimeout(() => {
    confetti({
      particleCount: 200,
      spread: 100,
      origin: { y: 0.5 },
      colors: colors
    });
  }, 1000);
};